<template>
    <b-card>
        <b-row>
            <b-col
                cols="12"
                md="3"
            >
                 <b-form-checkbox
                    v-model="$store.state.azFbaBasket.selectedBasketitems"
                    :value="fbaBasketProduct.id"
                    class="custom-control-secondary"
                />
                <div class="product-images-slider">
                    <swiper
                        v-if="productImages.length"
                        :options="swiperOptions"
                        ref="mySwiper"
                    >
                        <swiper-slide
                            v-for="(image, index) in productImages"
                            :key="index"
                            class="swiper-slide-image"
                        >
                            <img
                                :src="getImageUrl(image)"
                                :alt="product.name || 'Ürün görseli'"
                                class="product-image"
                            />
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                    <div
                        v-else
                        class="product-image-empty"
                    >
                        Görsel bulunamadı
                    </div>
                </div>
            </b-col>
            <b-col
                cols="12"
                md="6"
            >
                <div class="product-details">
                    <div class="detail-item" v-if="fbaBasketProduct.product.name">
                        <span class="detail-label">Ürün Adı:</span>
                        <span class="detail-value">{{ fbaBasketProduct.product.name }}</span>
                    </div>
                    <div class="detail-item" v-if="azProduct.merchant_sku">
                        <span class="detail-label">Asin:</span>
                        <span class="detail-value">{{ azProduct.merchant_sku }}</span>
                    </div>
                    <div class="detail-item" v-if="azStore_fba_product.fn_sku">
                        <span class="detail-label">FN SKU:</span>
                        <span class="detail-value">{{ azStore_fba_product.fn_sku }}</span>
                    </div>
                    <div class="detail-item" v-if="azProduct.id">
                        <span class="detail-label">Amazon SKU:</span>
                        <span class="detail-value">{{ azProduct.id }}</span>
                    </div>
                    <div class="detail-item" v-if="product.barcode">
                        <span class="detail-label">Ürün Barkod:</span>
                        <span class="detail-value">{{ product.barcode }}</span>
                    </div>

                    <div class="detail-item">
                        <span class="detail-label">Miktar:</span>
                        <span class="detail-value">
                            <b-form-input type="number" v-model="fbaBasketProduct.amount" @blur="changedAmount" />
                        </span>
                    </div>

                    <div class="detail-item" v-if="fbaBasketProduct.basket_name">
                        <span class="detail-label">Sepet Adı:</span>
                        <span class="detail-value">{{ fbaBasketProduct.basket_name }}</span>
                    </div>

                    <div class="detail-item" v-if="fbaBasketProduct.status">
                        <span class="detail-label">Durum:</span>
                        <span class="detail-value">{{ fbaBasketProduct.status }}</span>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
    export default {
        name: 'FbaBasketProduct',
        props: {
            fbaBasketProduct: {
                type: Object,
                required: true,
            },
        },
        components: {
            Swiper,
            SwiperSlide,
        },
        computed: {
            selectedBasketitems() {
                return this.$store.state.azFbaBasket.selectedBasketitems
            },
            product() {
                return this.fbaBasketProduct.product || {};
            },
            azProduct() {
                return this.fbaBasketProduct.az_product || {};
            },
            azStore_fba_product() {
                return this.fbaBasketProduct.az_store_fba_product || {};
            },
            productImages() {
                return this.product.images || [];
            },
        },
        data() {
            return {
                swiperOptions: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                },
            };
        },
        methods: {
            getImageUrl(image) {
                const apiPrefix = 'https://api.kitapfirsatlari.com/';
                if (typeof image === 'string') {
                    return apiPrefix + image;
                }
                return apiPrefix + (image.url || '');
            },
            changedSelectedBasketitems(checked) {
                if (checked) {
                    this.$store.commit('azFbaBasket/addSelectedBasketitem', this.fbaBasketProduct.id)
                    return
                }

                this.$store.commit('azFbaBasket/removeSelectedBasketitem', this.fbaBasketProduct.id)
            },
            changedAmount() {
                this.$store.dispatch('azFbaBasket/editBasket', {
                    id: this.fbaBasketProduct.id,
                    item: {
                        amount: this.fbaBasketProduct.amount
                    }
                });
            },
        },
    }
</script>

<style scoped>
.product-images-slider {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.swiper-container-vertical {
    height: 100%;
    width: 100%;
}

.swiper-slide-image {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 450px;
}

.product-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.product-image-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 450px;
    width: 100%;
    color: #666;
    background: #f8f9fa;
    border: 1px dashed #d8d8d8;
    border-radius: 8px;
}

.product-details {
    padding: 1rem;
    height: 100%;
}

.detail-item {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
    gap: 0.5rem;
}

.detail-label {
    font-weight: 600;
    color: #333;
    font-size: 1.05rem;
    white-space: nowrap;
}

.detail-value {
    color: #666;
    font-size: 1rem;
    word-break: break-word;
}

.swiper-pagination {
    bottom: 10px;
    z-index: 10;
}

.swiper-button-prev,
.swiper-button-next {
    background-color: rgba(0, 0, 0, 0.3);
    color: white;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.swiper-button-prev:after,
.swiper-button-next:after {
    font-size: 16px;
}
</style>